import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBookmarkRemove: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"bookmark-remove, off"} maskId="square-filled-radius-0-stroke-1-IconBookmarkRemove"><path d="M20 7.91733L22.7892 6.85476L23.1452 7.78925L1.21073 16.1452L0.854736 15.2108L3.99998 14.0126V2H20V7.91733Z" fill="currentColor"/><path d="M3.99998 22.3333V16.1528L20 10.0576V22.3333L12 18.0667L3.99998 22.3333Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBookmarkRemove;
